import React from 'react'
import './Style/Report.css'
function Report({subTotal,discount,lastPrice,product}) {


  return <div class="subject">
            <div class="name">
                <h3> Invoice to:</h3>
                <h4>Dwyane clark</h4>
                <p> 24 Dummy street Area,<br/> locaton,trreudh eedhhd <br/> 570xx33x</p>

            </div>

            <div class="payment">
                <h3> Payment Info:</h3>
                <div class="detalis">
                    <p>Account#: <br/> A/C Name <br/> Bank Detalis</p>
                    <p>1234 1478 9632 <br/> Lorem ipsum <br/> Add your Detalils</p>
                </div>
            </div>
            <div class="price">
                <div class="price-info">
                    <p> Sub Total:<br/> discount(%{product.discount}): </p>
                    <p> ${subTotal} <br/> ${discount}<br/></p>
                </div>
               <div class="total">
                   <p>Total</p>
                   <p>${lastPrice}</p>
               </div>
            </div>
    </div>
}

export default Report